import { Component, Inject } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthServices, AlertServices } from '@services';
import { ioValidators } from '@framework';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})

export class ForgotPasswordComponent {

    RecoverForm: FormGroup;
    isLoading = false;

    constructor(
        @Inject('AuthServices') private _authServices: AuthServices,
        @Inject('AlertServices') private _alertServices: AlertServices,
        private router: Router,
        private formBuilder: FormBuilder,
    ) { }

    EnterKeyTrigger(_event: KeyboardEvent) {
        if (_event.keyCode === 13) {
            this.onRecovery();
            _event.stopPropagation();
            _event.preventDefault();
        }
    }

    ngOnInit() {
        this.isLoading = false;
        this.RecoverForm = this.formBuilder.group({
            email: ['', Validators.compose([Validators.required, ioValidators.isEmail])]
        });

    }

    onRecovery() {
        if (this.RecoverForm.valid) {
            let _RecoveryData = this.RecoverForm.getRawValue();
            //console.log(_RecoveryData)
            this.isLoading = true;
        }
    }

    goToLogin() {
     this.router.navigate(['/login'], { });
    }

}
